export const currentStripePriceIds = {
  base: process.env.NEXT_PUBLIC_STRIPE_PRICE_BASE,
  plus: process.env.NEXT_PUBLIC_STRIPE_PRICE_PLUS,
  max: process.env.NEXT_PUBLIC_STRIPE_PRICE_MAX,
  baseYearly: process.env.NEXT_PUBLIC_STRIPE_PRICE_BASE_YEARLY,
  plusYearly: process.env.NEXT_PUBLIC_STRIPE_PRICE_PLUS_YEARLY,
  maxYearly: process.env.NEXT_PUBLIC_STRIPE_PRICE_MAX_YEARLY,
}

export const seatsPriceIds = {
  seatsMonthly: process.env.NEXT_PUBLIC_STRIPE_PRICE_SEATS_MONTHLY,
  seatsYearly: process.env.NEXT_PUBLIC_STRIPE_PRICE_SEATS_YEARLY,
}

export const stripePriceIds = {
  ...currentStripePriceIds,
  ...seatsPriceIds,
  creator: process.env.NEXT_PUBLIC_STRIPE_PRICE_CREATOR,
  entrepreneur: process.env.NEXT_PUBLIC_STRIPE_PRICE_ENTREPRENEUR,
  network: process.env.NEXT_PUBLIC_STRIPE_PRICE_NETWORK,
  creatorYearly: process.env.NEXT_PUBLIC_STRIPE_PRICE_CREATOR_YEARLY,
  entrepreneurYearly: process.env.NEXT_PUBLIC_STRIPE_PRICE_ENTREPRENEUR_YEARLY,
  networkYearly: process.env.NEXT_PUBLIC_STRIPE_PRICE_NETWORK_YEARLY,
  agency: process.env.NEXT_PUBLIC_STRIPE_PRICE_AGENCY,
  agencyYearly: process.env.NEXT_PUBLIC_STRIPE_PRICE_AGENCY_YEARLY,
  credit: process.env.NEXT_PUBLIC_STRIPE_PRICE_CREDIT,
  custom: process.env.NEXT_PUBLIC_STRIPE_PRICE_CUSTOM,
  customYearly: process.env.NEXT_PUBLIC_STRIPE_PRICE_CUSTOM_YEARLY,
  legacyCreator: process.env.NEXT_PUBLIC_STRIPE_PRICE_CREATOR_YEARLY_LEGACY,
  legacyEntrepreneur:
    process.env.NEXT_PUBLIC_STRIPE_PRICE_ENTREPRENEUR_YEARLY_LEGACY,
}

export const stripeCouponIds = {
  creator: process.env.NEXT_PUBLIC_STRIPE_COUPON_STARTER,
  entrepreneur: process.env.NEXT_PUBLIC_STRIPE_COUPON_PRO,
  network: process.env.NEXT_PUBLIC_STRIPE_COUPON_BUSINESS,
  agency: process.env.NEXT_PUBLIC_STRIPE_COUPON_AGENCY,
  yearly: process.env.NEXT_PUBLIC_STRIPE_COUPON_YEARLY,
  credit: process.env.NEXT_PUBLIC_STRIPE_COUPON_CREDIT,
  base: process.env.NEXT_PUBLIC_STRIPE_COUPON_BASE,
  plus: process.env.NEXT_PUBLIC_STRIPE_COUPON_PLUS,
  max: process.env.NEXT_PUBLIC_STRIPE_COUPON_MAX,
  baseYearly: process.env.NEXT_PUBLIC_STRIPE_COUPON_BASE_YEARLY,
  plusYearly: process.env.NEXT_PUBLIC_STRIPE_COUPON_PLUS_YEARLY,
  maxYearly: process.env.NEXT_PUBLIC_STRIPE_COUPON_MAX_YEARLY,
}

export const yearlyPrices = [
  process.env.NEXT_PUBLIC_STRIPE_PRICE_CREATOR_YEARLY,
  process.env.NEXT_PUBLIC_STRIPE_PRICE_NETWORK_YEARLY,
  process.env.NEXT_PUBLIC_STRIPE_PRICE_ENTREPRENEUR_YEARLY,
  process.env.NEXT_PUBLIC_STRIPE_PRICE_AGENCY_YEARLY,
  process.env.NEXT_PUBLIC_STRIPE_PRICE_CREATOR_YEARLY_LEGACY,
  process.env.NEXT_PUBLIC_STRIPE_PRICE_ENTREPRENEUR_YEARLY_LEGACY,
  process.env.NEXT_PUBLIC_STRIPE_PRICE_CREATOR_YEARLY_JULY_2024,
  process.env.NEXT_PUBLIC_STRIPE_PRICE_ENTREPRENEUR_YEARLY_JULY_2024,
  process.env.NEXT_PUBLIC_STRIPE_PRICE_NETWORK_YEARLY_JULY_2024,
  process.env.NEXT_PUBLIC_STRIPE_PRICE_AGENCY_YEARLY_JULY_2024,
  process.env.NEXT_PUBLIC_STRIPE_PRICE_SEATS_YEARLY,
]

export const yearlyPricesOnCron = [
  process.env.NEXT_PUBLIC_STRIPE_PRICE_BASE_YEARLY,
  process.env.NEXT_PUBLIC_STRIPE_PRICE_PLUS_YEARLY,
  process.env.NEXT_PUBLIC_STRIPE_PRICE_MAX_YEARLY,
]

export function getStripePriceId(planId) {
  return stripePriceIds[planId]
}

export type PlanId = keyof typeof stripePriceIds

// Get friendly plan ID ("basic", "premium", etc) by Stripe plan ID
// Used in auth.js to include planId in the user object
export function getFriendlyPlanId(stripePriceId) {
  return Object.keys(stripePriceIds).find(
    (key) => stripePriceIds[key] === stripePriceId
  )
}

export function getStripeCouponId(planId) {
  switch (planId) {
    case 'base':
      return stripeCouponIds.base
    case 'plus':
      return stripeCouponIds.plus
    case 'max':
      return stripeCouponIds.max
    case 'creator':
      return stripeCouponIds.creator
    case 'entrepreneur':
      return stripeCouponIds.entrepreneur
    case 'network':
      return stripeCouponIds.network
    case 'agency':
      return stripeCouponIds.agency
    case 'base':
      return stripeCouponIds.base
    case 'plus':
      return stripeCouponIds.plus
    case 'max':
      return stripeCouponIds.max
    case 'baseYearly':
      return stripeCouponIds.baseYearly
    case 'plusYearly':
      return stripeCouponIds.plusYearly
    case 'maxYearly':
      return stripeCouponIds.maxYearly
    case 'networkYearly':
    case 'creatorYearly':
    case 'agencyYearly':
    case 'entrepreneurYearly':
      return stripeCouponIds.yearly
    case 'credit':
      return stripeCouponIds.credit
    default:
      console.log('No coupon found for planId:', planId, 'returning null')
      return null
  }
}
